import app from '../../app.module.css';

export const NOT_FOUND_ERROR = 'Page could not be found.';
const NotFound = () => <h1 className={app.notFound}>{NOT_FOUND_ERROR}</h1>;

export default NotFound;
